import React from 'react'
import { Hero } from 'react-bulma-components'
import styled from 'styled-components'
import { StaticImage } from 'gatsby-plugin-image'
import { Level } from 'react-bulma-components'
import { device } from '../../utils/device'
import {
    StyledHeading,
    StyledContainer,
    StyledContent,
    StyledHero,
} from '../../utils/commonStyles'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const CustomStyledHero = styled(StyledHero)`
    min-height: 200px;
`
const StyledLevel = styled(Level)`
    @media ${device.mobile} {
        display: grid;
        grid-template-columns: 50% 50%;
    }
`
const StyledLevelItem = styled(Level.Item)`
    @media ${device.mobile} {
        flex: 1 50%;
    }
`

// Named function so its not anonymous to debug
export default function Partners() {
    const { t } = useTranslation()
    return (
        <CustomStyledHero>
            <Hero.Body>
                <StyledContainer>
                    <StyledHeading className={'has-text-centered'} size={1}>
                        {t('onas.partners.title')}
                    </StyledHeading>

                    <StyledContent className={'has-text-centered'}>
                        <p style={{ maxWidth: '90%', margin: '0 auto' }}>
                        {t('onas.partners.description')}
                        </p>
                    </StyledContent>
                    <StyledLevel>
                        <StyledLevelItem>
                            <StaticImage
                                src="../../images/lg.svg"
                                alt="LG"
                                placeholder="blurred"
                                objectFit="contain"
                                width={100}
                            />
                        </StyledLevelItem>
                        <StyledLevelItem>
                            <StaticImage
                                src="../../images/novotegra.svg"
                                alt="Novotegra"
                                placeholder="blurred"
                                objectFit="contain"
                                width={100}
                            />
                        </StyledLevelItem>
                        <StyledLevelItem>
                            <StaticImage
                                src="../../images/solaredge.svg"
                                alt="Solar Edge"
                                placeholder="blurred"
                                objectFit="contain"
                                width={150}
                            />
                        </StyledLevelItem>
                        <StyledLevelItem>
                            <StaticImage
                                src="../../images/fronius.svg"
                                alt="Fronius"
                                placeholder="blurred"
                                objectFit="contain"
                                width={100}
                            />
                        </StyledLevelItem>
                        <StyledLevelItem>
                            <StaticImage
                                src="../../images/longi.svg"
                                alt="Longi"
                                placeholder="blurred"
                                objectFit="contain"
                                width={100}
                            />
                        </StyledLevelItem>
                        <StyledLevelItem>
                            <StaticImage
                                src="../../images/trina.png"
                                alt="Trina"
                                placeholder="blurred"
                                objectFit="contain"
                                width={100}
                            />
                        </StyledLevelItem>
                    </StyledLevel>
                    <StyledLevel>
                        <StyledLevelItem>
                            <StaticImage
                                src="../../images/jinko.svg"
                                alt="Jinko"
                                placeholder="blurred"
                                objectFit="contain"
                                width={100}
                            />
                        </StyledLevelItem>
                        <StyledLevelItem>
                            <StaticImage
                                src="../../images/tigo.svg"
                                alt="Tigo"
                                placeholder="blurred"
                                objectFit="contain"
                                width={100}
                            />
                        </StyledLevelItem>
                        <StyledLevelItem>
                            <StaticImage
                                src="../../images/solis.png"
                                alt="Solis"
                                placeholder="blurred"
                                objectFit="contain"
                                width={150}
                            />
                        </StyledLevelItem>
                        <StyledLevelItem>
                            <StaticImage
                                src="../../images/consol.png"
                                alt="Consol"
                                placeholder="blurred"
                                objectFit="contain"
                                width={75}
                            />
                        </StyledLevelItem>
                        <StyledLevelItem>
                            <StaticImage
                                src="../../images/klima-elektro.png"
                                alt="Consol"
                                placeholder="blurred"
                                objectFit="contain"
                                width={150}
                            />
                        </StyledLevelItem>
                    </StyledLevel>
                </StyledContainer>
            </Hero.Body>
        </CustomStyledHero>
    )
}
